import Vue from 'vue';
import vSelect from 'vue-select';
import VueTheMask from 'vue-the-mask';
import JsonCSV from 'vue-json-csv';
import VueScrollTo from 'vue-scrollto';
import VueTableDynamic from 'vue-table-dynamic';
import * as Icon from 'vue-awesome';
import lodash from 'lodash';
import moment from 'moment';
import resource from 'vue-resource';
import VueGlobalVar from 'vue-global-var';
import firebase from 'firebase';
import firebaseConfig from '../firebaseConfig.json';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import './assets/js/components';

Vue.config.productionTip = false;
Vue.prototype.moment = moment;
Vue.prototype.bus = new Vue();
Vue.use(resource);
Vue.component('v-select', vSelect);
Vue.use(VueTableDynamic);
Vue.component('v-icon', Icon);
Vue.component('downloadCsv', JsonCSV);
Vue.use(VueScrollTo);
Vue.use(VueTheMask);


firebase.initializeApp(firebaseConfig);
firebase.analytics();

Vue.use(VueGlobalVar, {
  globals: {
    db: firebase.firestore(),
    firestore: firebase.firestore,
    auth: firebase.auth(),
    _: lodash,
  },
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
